// extracted by mini-css-extract-plugin
export var deleteModal = "_gj-0";